// CanvasCapture.js - Utility to capture the React Flow canvas as an image
import { toBlob } from 'html-to-image';

export const captureCanvas = async () => {
  // Find the React Flow canvas container
  const reactFlowContainer = document.querySelector('.react-flow');

  if (!reactFlowContainer) {
    console.error('Canvas element not found');
    return null;
  }

  try {
    // Temporarily boost SVG z-index to ensure edges are captured
    // Handle ALL SVGs in the edges container (there may be one per edge)
    const allEdgeSvgs = document.querySelectorAll('.react-flow__edges svg');
    const originalStyles = [];

    allEdgeSvgs.forEach((svg) => {
      originalStyles.push(svg.style.zIndex);
      svg.style.zIndex = '1000';

      // Ensure all paths have explicit stroke colors
      const paths = svg.querySelectorAll('path');
      paths.forEach(path => {
        const computedStyle = window.getComputedStyle(path);
        if (!path.getAttribute('stroke') || path.getAttribute('stroke') === 'none') {
          path.setAttribute('stroke', computedStyle.stroke || '#b1b1b7');
        }
        path.setAttribute('stroke-width', computedStyle.strokeWidth || '2');
      });
    });

    // Capture straight to a Blob. The previous toPng + fetch(dataUrl) route
    // failed in production: the CSP's connect-src 'self' blocks fetching data: URLs.
    const blob = await toBlob(reactFlowContainer, {
      backgroundColor: '#0d0d0d',
      pixelRatio: 1,
      filter: (node) => {
        // Filter out minimap and controls
        if (node.classList?.contains('react-flow__minimap') ||
            node.classList?.contains('react-flow__controls')) {
          return false;
        }
        return true;
      }
    });

    // Restore original z-index values
    allEdgeSvgs.forEach((svg, index) => {
      svg.style.zIndex = originalStyles[index] || '';
    });

    if (!blob) {
      throw new Error('html-to-image returned no image data');
    }
    return blob;

  } catch (error) {
    console.error('Failed to capture canvas:', error);
    throw error;
  }
};

export default captureCanvas;
